module.exports = __webpack_public_path__ + "img/1.785fe638.png";